import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { utils } from '@app/shared/utils';
import { Tab } from '@teorema/patron';
import { NotificationConfigurationComponent } from './notification-configuration/notification-configuration.component';
import { PagedListComponent } from './paged-list/paged-list.component';
import { SendingFormComponent } from './sending-form/sending-form.component';

@Component({
  selector: 'patron-notifications',
  templateUrl: './notifications.component.html',
  standalone: false,
})
export class NotificationsComponent implements OnInit, AfterViewInit {
  @ViewChild('sendingTab') sendingTab?: TemplateRef<any>;
  @ViewChild('sendingTemplate') sendingTemplate?: SendingFormComponent;
  @ViewChild('receivedListTab') receivedListTab?: TemplateRef<any>;
  @ViewChild('receivedPagedList') receivedPagedList?: PagedListComponent;
  @ViewChild('sentListTab') sentListTab?: TemplateRef<any>;
  @ViewChild('sentPagedList') sentPagedList?: PagedListComponent;
  @ViewChild('subscriptionTab') subscriptionTab?: TemplateRef<any>;
  @ViewChild('subscriptionTemplate') subscriptionTemplate?: NotificationConfigurationComponent;

  tabs: Tab[] = [];

  constructor() {}

  ngOnInit() {}

  ngAfterViewInit(): void {
    this.tabs = [
      {
        header: 'Recebidas',
        template: this.receivedListTab!,
        index: 1,
      },
      {
        header: 'Enviadas',
        template: this.sentListTab!,
        index: 2,
      },
      {
        header: 'Inscrição',
        template: this.subscriptionTab!,
        index: 3,
      },
    ];

    if (utils.checkAccess(['Notifications'], false, true).result) {
      this.tabs.unshift({
        header: 'Enviar',
        template: this.sendingTab!,
        index: 0,
      });
    }
  }

  tabChanged(index: number) {
    switch (index) {
      case 1: {
        if (this.receivedPagedList && !this.receivedPagedList.wasFirstSearchRan) {
          this.receivedPagedList.paginate();
        }
        break;
      }
      case 2: {
        if (this.sentPagedList && !this.sentPagedList.wasFirstSearchRan) {
          this.sentPagedList.paginate();
        }
        break;
      }
      case 3: {
        if (this.subscriptionTemplate) {
          this.subscriptionTemplate.init();
        }
        break;
      }
    }
  }
}
